'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2016/11/3.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRating = require('react-rating');

var _reactRating2 = _interopRequireDefault(_reactRating);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reduxForm = require('redux-form');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderEvaluateComponent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'orderEvaluateForm',
  fields: ['qualityStar', 'serviceStar', 'timelyStar', 'evaluate']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(OrderEvaluateComponent, _Component);

  function OrderEvaluateComponent() {
    (0, _classCallCheck3.default)(this, OrderEvaluateComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderEvaluateComponent).call(this));
  }
  // const styles = require('./OrderEvaluate.scss');


  (0, _createClass3.default)(OrderEvaluateComponent, [{
    key: 'onEvaluateChange',
    value: function onEvaluateChange(value, type) {
      // console.log(value);
      var _props$fields = this.props.fields;
      var qualityStar = _props$fields.qualityStar;
      var serviceStar = _props$fields.serviceStar;
      var timelyStar = _props$fields.timelyStar;
      var evaluate = _props$fields.evaluate;

      switch (type) {
        case 'quality':
          qualityStar.onChange(value);
          break;
        case 'service':
          serviceStar.onChange(value);
          break;
        case 'timely':
          timelyStar.onChange(value);
          break;
        case 'serviceEvaluate':
          evaluate.onChange(value);
          break;
        default:
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var _props$fields2 = _props.fields;
      var qualityStar = _props$fields2.qualityStar;
      var serviceStar = _props$fields2.serviceStar;
      var timelyStar = _props$fields2.timelyStar;
      var evaluate = _props$fields2.evaluate;
      var serviceEvaluateData = _props.serviceEvaluateData;
      var handleSubmit = _props.handleSubmit;

      var styles = require('./ServiceOrderEvaluateComponent.scss');
      var isEvaluated = false;
      if (serviceEvaluateData instanceof Array && serviceEvaluateData.length > 0 && serviceEvaluateData[0].isEvaluated === '1') {
        isEvaluated = true;
      }
      var serviceStarNumber = parseInt(serviceStar.value || serviceStar.initialValue, 10);
      if (isNaN(serviceStarNumber)) {
        serviceStarNumber = 0;
      }
      var qualityStarNumber = parseInt(qualityStar.value || qualityStar.initialValue, 10);
      if (isNaN(qualityStarNumber)) {
        qualityStarNumber = 0;
      }
      var timelyStarNumber = parseInt(timelyStar.value || timelyStar.initialValue, 10);
      if (isNaN(timelyStarNumber)) {
        timelyStarNumber = 0;
      }
      var evaluateData = evaluate.value || evaluate.initialValues;
      // console.log(qualityStar);
      // console.log(evaluate);
      var serviceEvaluateDiv = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          { className: styles.serviceEvaluate },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.tip },
              '服务质量'
            ),
            _react2.default.createElement(_reactRating2.default, { initialRate: qualityStarNumber,
              readonly: isEvaluated,
              empty: 'fa fa-star-o fa-2x grey mr7',
              full: 'fa fa-star fa-2x red mr7',
              onChange: function onChange(rate) {
                return _this2.onEvaluateChange(rate, 'quality');
              } })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.tip },
              '服务态度'
            ),
            _react2.default.createElement(_reactRating2.default, { initialRate: serviceStarNumber,
              readonly: isEvaluated,
              empty: 'fa fa-star-o fa-2x grey mr7',
              full: 'fa fa-star fa-2x red mr7',
              onChange: function onChange(rate) {
                return _this2.onEvaluateChange(rate, 'service');
              } })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.tip },
              '按时交付'
            ),
            _react2.default.createElement(_reactRating2.default, { initialRate: timelyStarNumber,
              readonly: isEvaluated,
              empty: 'fa fa-star-o fa-2x grey mr7',
              full: 'fa fa-star fa-2x red mr7',
              onChange: function onChange(rate) {
                return _this2.onEvaluateChange(rate, 'timely');
              } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.serviceTip },
          '评价晒单'
        ),
        isEvaluated ? _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: 700, float: 'left', marginTop: 30 },
          inputType: 'textarea',
          disabled: isEvaluated,
          inputStyle: { float: 'left', width: 700 },
          fieldStyle: { height: 150 },
          inputPlaceholder: '',
          value: evaluateData }) : _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: 700, float: 'left', marginTop: 30 },
          afterInit: function afterInit(value) {
            return _this2.onEvaluateChange(value, 'serviceEvaluate');
          },
          inputType: 'textarea',
          disabled: isEvaluated,
          inputStyle: { float: 'left', width: 700 },
          fieldStyle: { height: 150 },
          inputPlaceholder: '',
          formProps: evaluate })
      );

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.topTitle },
          '订单编号：',
          serviceEvaluateData && serviceEvaluateData.length > 0 ? serviceEvaluateData[0].id : '',
          _react2.default.createElement(
            'div',
            { className: styles.orderStatus },
            '状态：',
            serviceEvaluateData && serviceEvaluateData.length > 0 ? serviceEvaluateData[0].status : ''
          )
        ),
        _react2.default.createElement('div', { className: styles.xiola }),
        _react2.default.createElement('div', { className: styles.xiolb }),
        _react2.default.createElement('div', { className: styles.xiolc }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.topTitle,
            style: { paddingTop: '8px', float: 'right' } },
          serviceEvaluateData && serviceEvaluateData.length > 0 ? serviceEvaluateData[0].time : ''
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.newPage },
          _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle },
            '服务评价'
          ),
          _react2.default.createElement('div', { className: styles.linka }),
          _react2.default.createElement('div', { className: 'clear' }),
          serviceEvaluateDiv,
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.linkBtn, style: { width: isEvaluated ? 120 : 305 } },

          // isEvaluated ? <Link className={styles.btn} to={'/serviceorderlist'}>返回</Link> : <div className={styles.btn} onClick={handleSubmit}>评价提交</div>
          isEvaluated ? '' : _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: handleSubmit, style: { marginRight: 60 } },
            '评价提交'
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.btn, to: '/serviceorderlist' },
            '返回'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return OrderEvaluateComponent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  // data: PropTypes.object
  serviceEvaluateData: _react.PropTypes.array
}, _temp)) || _class);
exports.default = OrderEvaluateComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderEvaluateComponent/ServiceOrderEvaluateComponent.js
 ** module id = 1421
 ** module chunks = 0
 **/